<script>
  export let isModal;
</script>

{#if isModal}
  <p class="privacy-eula">
    By continuing, you agree to Higher Learning Technologies’ <a href="https://builtbyhlt.com/eula" rel="noreferrer" target="_blank">Terms & Conditions</a> and <a href="https://builtbyhlt.com/privacy" rel="noreferrer" target="_blank">Privacy Policy</a>
  </p>
{/if}
